<script>
    import GameObject from '@/components/page-provider-and-game-edit/GameObject.vue';
    import IconArrowExpand from '@/components/icon/IconArrowExpand.vue';

    import IconCrown from '@/components/icon/IconCrown.vue';
    import IconShow from '@/components/icon/IconShow.vue';

    export default {
        data() {
            return {
                isCollapse: false,
            }
        },
        components: {
            GameObject: GameObject,
            IconArrowExpand: IconArrowExpand,

            IconCrown: IconCrown,
            IconShow: IconShow,
        },
        props: {
            provider: Object,
        },
        methods: {
            async editProvider() {
                this.$store.commit('PAG_PROVIDER_EDIT_SET', this.provider);
                this.$store.commit('IS_SHOW_PAG_RROVIDER_EDIT', true);
                await this.$store.dispatch('CHECK_PROVIDER_EDIT');
            },
            async collapseProvider() {
                this.isCollapse = !this.isCollapse;
            }
        }
    }
</script>


<template>
    <div class="right_header cursor_pointer">
        <div 
            @click="editProvider"
            class="right_header_text cursor_pointer_label"
        >
            <label
                class="ml_5"
            >[{{ provider['id'] }}]</label>
            <IconCrown 
                v-if="provider['is_premium'] === true"
                class="ml_5"
                iconWidth = "18px"
                iconHeight = "18px"
            />
            <IconShow 
                v-if="provider['is_default'] === true"
                class="ml_5"
                iconWidth = "18px"
                iconHeight = "18px"
            />
            <label
                class="ml_5"
            >{{ provider['name'] }}</label>
        </div>
        <div 
            @click="collapseProvider"
            class="right_header_another"
        >
            <IconArrowExpand
                class="mr_5"
                iconWidth = "18px"
                iconHeight = "18px"
                :isActive = "isCollapse" 
            />
        </div>
    </div>
    <ul 
        v-if="isCollapse === false"
        class="clear_ul"
    >
        <GameObject 
            v-for="(gameValue, gameIndex) in provider['game_name']" :key="gameIndex"
            :game="gameValue"
        />
    </ul>
</template>